export function enums () {
  return {
    RefundText0: {
      '0': '买家退款',
      '1': '已提交退款申请，正在审核中...',
      '2': '商家已同意退货申请，请退货给商家',
      '3': '退款成功',
    },
    RefundText1: {
      '0': '买家退款',
      '1': '已提交退款申请，正在审核中...',
      '2': '商家已同意退货申请，请退货给商家',
      '3': '请等待商家收货并退款',
      '4': '退款成功',
    },
    RefundText2: {
      '0': '待确认',
      '1': '退款成功',
      '2': '退款失败'
    },
    FreightType: {
      '0': '快递',
      '1': '物流',
      '2': '自提'
    },
    ProductType: {
      '0': '电子元器件',
      '1': '电子产品',
      '2': '其他产品'
    },
    SupplyType: {
      '0': '原厂',
      '1': '代理商',
      '2': '分销商'
    },
    SupplyUpload: {
      '0': '上传商标证明',
      '1': '上传代理授权证明',
      '2': '上传经销授权书'
    },
    RefundReason: {
      '0': '包装不合格',
      '1': '产品错发',
      '2': '联系人填写错误',
      '3': '包装损坏',
      '4': '联系方式错误',
      '5': '规格选择错误',
    },
    TicketType:{
      '0': '增值税专票',
      '1': '普通发票',
      '2': '不开票',
    },
    IssueType: {
      '0': '不开发票',
      '1': '专票',
      '2': '普票',
    },
    toKV: function (obj) {
      let arr = []
      for (let index in obj) {
        arr.push({id: index, name: obj[index]})
      }
      return arr
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/enums.js